import { ref } from "vue";
import { usePrismic } from "@prismicio/vue";

export function useDocumentByUID(type, uid) {
  const data = ref(null);
  const state = ref("pending");
  const { client } = usePrismic();

  client
    .getByUID(type, uid)
    .then((doc) => {
      data.value = doc;
      state.value = "success";
    })
    .catch(() => {
      state.value = "error";
    });

  return { data, state };
}
